import React, { useState } from 'react';
import EdutoryCertificateCard from './EdutoryCertificateCard';
import EdutoryCourseCard from './EdutoryCourseCard';
import './EdutorySection.css';

const EdutorySection = ({ courses = [], certifications = [] }) => {
  const [activeTab, setActiveTab] = useState('courses');

  // Don't render if no Edutory content
  if (courses.length === 0 && certifications.length === 0) {
    return null;
  }

  return (
    <div className="edutory-section">
      <div className="edutory-header">
        <div className="edutory-branding">
          <div className="edutory-logo">
            <svg
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2L2 7L12 12L22 7L12 2Z"
                fill="#667eea"
                stroke="#667eea"
                strokeWidth="2"
                strokeLinejoin="round"
              />
              <path
                d="M2 17L12 22L22 17"
                stroke="#764ba2"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2 12L12 17L22 12"
                stroke="#667eea"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="edutory-title-wrapper">
            <h2 className="edutory-section-title">Edutory Courses & Certificates</h2>
            <p className="edutory-subtitle">
              Professional courses and certifications from Edutory.net
            </p>
          </div>
        </div>

        <div className="edutory-tabs">
          <button
            className={`tab-btn ${activeTab === 'courses' ? 'active' : ''}`}
            onClick={() => setActiveTab('courses')}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 14L21 9L12 4L3 9L12 14Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinejoin="round"
              />
            </svg>
            Courses ({courses.length})
          </button>
          <button
            className={`tab-btn ${activeTab === 'certificates' ? 'active' : ''}`}
            onClick={() => setActiveTab('certificates')}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                fill="currentColor"
              />
            </svg>
            Certificates ({certifications.length})
          </button>
        </div>
      </div>

      <div className="edutory-content">
        {activeTab === 'courses' && (
          <div className="courses-grid">
            {courses.length > 0 ? (
              courses.map((course, index) => (
                <EdutoryCourseCard key={course.id || index} course={course} />
              ))
            ) : (
              <div className="empty-state">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 14L21 9L12 4L3 9L12 14Z"
                    stroke="#cbd5e0"
                    strokeWidth="2"
                    strokeLinejoin="round"
                  />
                </svg>
                <p>No courses available for this role yet.</p>
              </div>
            )}
          </div>
        )}

        {activeTab === 'certificates' && (
          <div className="certificates-grid">
            {certifications.length > 0 ? (
              certifications.map((certificate, index) => (
                <EdutoryCertificateCard key={certificate.id || index} certificate={certificate} />
              ))
            ) : (
              <div className="empty-state">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                    fill="#cbd5e0"
                  />
                </svg>
                <p>No certificates available for this role yet.</p>
              </div>
            )}
          </div>
        )}
      </div>

      <div className="edutory-footer">
        <a
          href="https://www.edutory.net"
          target="_blank"
          rel="noopener noreferrer"
          className="visit-edutory-btn"
        >
          <span>Visit Edutory.net</span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path
              d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11M15 3H21M21 3V9M21 3L10 14"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </a>
      </div>
    </div>
  );
};

export default EdutorySection;
